export default "__VITE_ASSET__NKqbAV57__"